import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=227d1c22&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import "./Header.vue?vue&type=style&index=0&id=227d1c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d1c22",
  null
  
)

export default component.exports